import { operatorOptions, semVerOperatorOptions } from './constants';
import type { Clause } from './types';

export interface AttributeRestrictions {
  /** Force a specific expected value type regardless of operator */
  forceValueType?: 'string' | 'number';
  /** Restrict available operators to specific set */
  allowedOperators?: typeof operatorOptions;
}

/**
 * Configuration for built-in attribute restrictions
 * Docs: https://launchdarkly.com/docs/home/flags/built-in-attributes
 */
const BUILTIN_ATTRIBUTE_RESTRICTIONS: Record<string, AttributeRestrictions> = {
  name: {
    forceValueType: 'string',
    allowedOperators: operatorOptions,
  },
  kind: {
    forceValueType: 'string',
    allowedOperators: operatorOptions,
  },
  key: {
    forceValueType: 'string',
    allowedOperators: operatorOptions.concat(semVerOperatorOptions),
  },
};

export function getValueType(clause: Clause): 'string' | 'number' | undefined {
  return BUILTIN_ATTRIBUTE_RESTRICTIONS[clause.attribute]?.forceValueType;
}

export function getOperators(clause: Clause): typeof operatorOptions | undefined {
  return BUILTIN_ATTRIBUTE_RESTRICTIONS[clause.attribute]?.allowedOperators;
}
